import { memo } from "react";
import { useTranslate } from "helpers";
import { TableSearch } from "ui/components/Table/TableSearch";
import { initialDataWithPagination } from "services/api/consts";
import { FLEET_VEHICLE_HISTORY_SEARCH_COLUMNS } from "./consts";
import { VehicleHistorySearchResultsProps } from "./types";

const VehicleHistorySearchResults: React.FC<VehicleHistorySearchResultsProps> = (props) => {
  const { searchResults, isLoading, onPaginationChange, vehicle } = props;
  const { t } = useTranslate();

  return (
    <TableSearch
      columns={FLEET_VEHICLE_HISTORY_SEARCH_COLUMNS(t, vehicle)}
      data={searchResults.data}
      selectedRows={[]}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      isLoading={isLoading}
    />
  );
};

export default memo(VehicleHistorySearchResults);
